import { Dialog } from "@/components/ui/Dialog";
import { Autocomplete } from "@/components/Autocomplete";
import { getRecentAuftraege, searchAuftraege, type AuftragLookup } from "@/lib/material";
import type { AuftragMini } from "@/lib/orders";
import { formatAuftragLookupLabel } from "@/features/globalUpload/formatAuftragLookupLabel";
import { formatAuftragsnummerDisplay } from "@/lib/orderDraftUtils";

function lookupToMini(a: AuftragLookup & { ordnernummer?: string; nummer?: number }): AuftragMini {
  const raw = a.auftragsnummer || "";
  const parts = raw.split("#");
  return {
    id: a.id,
    jahr: a.jahr ?? new Date().getFullYear(),
    ordnernummer: a.ordnernummer || parts[0] || "",
    nummer: a.nummer ?? (parts.length > 1 ? Number(parts[1]) : null),
    auftragsnummer: raw,
    auftragsnummer_display: formatAuftragsnummerDisplay({
      id: a.id,
      jahr: a.jahr ?? new Date().getFullYear(),
      auftragsnummer: raw,
    }),
    ort: a.ort,
    beschreibung: a.beschreibung,
  };
}

export function AuftragPickerDialog({
  open,
  onClose,
  onPick,
}: {
  open: boolean;
  onClose: () => void;
  onPick: (auftrag: AuftragMini) => void;
}) {
  return (
    <Dialog open={open} onClose={onClose} title="Auftrag wählen" size="md" zIndexClass="z-[130]">
      <Autocomplete<AuftragLookup>
        label="Auftrag"
        placeholder="Auftragsnummer, Ort oder Beschreibung …"
        minChars={0}
        loadOptions={async (q) => {
          const list = q.trim() ? await searchAuftraege(q) : await getRecentAuftraege({ limit: 15 });
          return list.map((a) => ({
            key: String(a.id),
            label: formatAuftragLookupLabel(a),
            description: a.beschreibung || undefined,
            value: a,
          }));
        }}
        onSelect={(opt) => {
          if (opt?.value) {
            onPick(lookupToMini(opt.value));
            onClose();
          }
        }}
      />
    </Dialog>
  );
}
